// ============================================================================
// MINIMUM CUT - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'min-cut',
  name: 'Minimum Cut',
  category: 'Graphs',
  complexity: {
    time: 'O(V * E^2)',
    space: 'O(V^2)'
  },
  description: 'Algorithm to find the minimum cut in a flow network using the Max-Flow Min-Cut theorem. After computing maximum flow, performs BFS from source to identify reachable vertices, then finds edges between reachable and unreachable sets that form the minimum cut.'
};
